<script setup lang="ts">
import { DefenceQuestion } from "../stores/application";
import { required, helpers } from "@vuelidate/validators";
import { RadioSet, Radio, Question } from "./fields";
import { ref } from "vue";

const props = defineProps<{
    question: DefenceQuestion,
    questionRow: boolean,
}>();

const questionValue = ref(props.question.value);
const emit = defineEmits(["valueChange"]);

</script>
<template>
    <Question
        :name="props.question.name"
        :tooltip="props.question.tooltip"
        :input-class="questionRow ? 'col-md-5' : undefined"
        :label-class="questionRow ? 'order-first col-md-6 col-form-label pt-0' : undefined"
    >
        <RadioSet>
            <Radio
                v-model="questionValue"
                title="Yes"
                :value="true"
                :validation="{ required: helpers.withMessage(`The ${props.question.errorLabel} field is required.`, required) }"
                @update:model-value="emit('valueChange', questionValue)"
            />
            <Radio
                v-model="questionValue"
                title="No"
                :value="false"
                :validation="{ required: helpers.withMessage(`The ${props.question.errorLabel} field is required.`, required) }"
                @update:model-value="emit('valueChange', questionValue)"
            />
        </RadioSet>

        <template #label>
            <span v-html="props.question.label" />
        </template>
    </Question>

    <div
        v-if="props.question.extraInfoText && questionValue === props.question.failState && typeof props.question.failState === 'boolean'"
        class="d-flex"
    >
        <p
            class="col-12 alert alert-warning"
            v-html="props.question.extraInfoText"
        />
    </div>

    <div
        v-if="props.question.failText && questionValue === props.question.failState && typeof props.question.failState === 'boolean'"
        class="d-flex"
    >
        <p
            class="col-12 alert alert-danger"
            v-html="props.question.failText"
        />
    </div>
</template>

<style scoped>
</style>
